import React, { useRef, useState } from "react";
import classNames from "classnames/bind";
import { DateTimeIcon } from "../Icons/Icons";
import styles from "./DateTimePicker.module.css";
import { formatDDMMYY, formatDates } from "../../utils";
import "react-calendar/dist/Calendar.css";

import Calendar from "react-calendar";
import useDetectElement from "../../hooks/useDetectElement";
import { PlayBackContext } from "../../contexts";
const cx = classNames.bind(styles);
const CustomCalendar = ({
  title,
  disabled,
  value,
  size = "small",
  onChange,
  styles,
  className,
  dayHl
}) => {
  const ref = useRef();
  const refDiv = useRef();
  const [time, setTime] = useState();
  const [show, setShow] = useState(false);
  const data = useDetectElement(ref);
  useState(() => {
    const dateNow = new Date();
    setTime(value);
  }, [value]);
  React.useEffect(() => {
    let handler = (e) => {
      if (
        !ref?.current?.contains(e.target) &&
        !refDiv?.current?.contains(e.target)
      ) {
        setShow(false);
      }
      else {
        setShow(true)
      }
    };

    document.addEventListener("click", handler);

    return () => {
      document.removeEventListener("click", handler);
    };
  }, []);
  const events = ["03-05-2023", "04-05-2023", "05-05-2023"];
  return (
    <div

      style={{ ...styles }}
      className={cx("form-control")}
    >
      <label className={cx("title")}>{title}</label>
      <div
        ref={refDiv}
        style={{
          height: 36,
          border: "1px solid #ccc",
          minWidth: 300,
          width:"100%",
          display: "flex",
          alignItems: "center",
          marginTop: 8,
          borderRadius: 4,
        }}
      >
        {" "}
        <span className={cx(`${size === "small" ? "icon-small-c" : "icon"}`)}>
          <DateTimeIcon />
        </span>
        <span className={cx("value")}>{formatDDMMYY(time)}</span>
      </div>
      {show && (
        <div ref={ref}>
          <Calendar
            value={time}
            onChange={(value, e) => {
              setTime(value);
              onChange(value);
            }}
            className={cx("dateTime")}
            tileClassName={({ date,...rest }) => {
              let day = date.getDate();
              let mouth = date.getMonth() + 1;
              if (mouth < 10) {
                mouth = "0" + mouth;
              }
              if (date.getDate() < 10) {
                day = "0" + day;
              } 
              if (dayHl?.length > 0) {
                const map = dayHl?.map(item => formatDates(item))
                const dateRe = day + "-" + mouth + "-" + date.getFullYear();
                if (map.find((val) => val === dateRe && val !== formatDates(time))) {
                  return cx("hightlight");
                }
              }
            }}
          />
        </div>
      )}
    </div>
  );
};

export default CustomCalendar;
